import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

/**
 * Interface pour un lien symbolique vers un dossier de copropriétaire
 */
export interface CoOwnerFolderLink {
  folder_id: string // ID virtuel
  folder_name: string
  folder_slug: string
  is_symbolic_link: boolean
  linked_folder_id: string | null // ID du dossier physique
  is_active: boolean
  co_owner_id: string
  co_owner_first_name: string
  co_owner_last_name: string
  sort_order: number
}

const CO_OWNER_FOLDERS_QUERY_KEY = ['co-owner-folders']

/**
 * Récupérer les "dossiers" de copropriétaires pour une résidence (liens symboliques dynamiques)
 */
export function useCoOwnerFolders(residenceId?: string, showInactive: boolean = false) {
  return useQuery({
    queryKey: [...CO_OWNER_FOLDERS_QUERY_KEY, residenceId, showInactive],
    queryFn: async () => {
      if (!residenceId) return []

      const { data, error } = await supabase.rpc(
        'get_owner_folders_for_residence' as any,
        {
          p_residence_id: residenceId,
          p_show_inactive: showInactive,
        }
      )

      if (error) throw error
      return (data || []) as CoOwnerFolderLink[]
    },
    enabled: !!residenceId,
  })
}

/**
 * Vérifier si un dossier est le dossier système "Copropriétaires" d'une résidence
 */
export function isCoOwnerSystemFolder(folder: {
  suggested_category?: string | null
  name: string
}): boolean {
  return folder.suggested_category === 'coproprietaire' || folder.name === 'Copropriétaires'
}
